import moment from "moment"
import {capitalizeFirstLetter} from "utils/text_utils"
import "./Existing.css"

export default function Existing(props) {

    const {rescue, setExisting} = props

    const reset = () => {
        rescue.reload()
        setExisting(false)
    }
    
    const cont = () => {
        setExisting(false)
    } 


    return <section id="existing" className="white shadow">
    
        {rescue.hasId ? <h5>Za ovu listu postoje izmene koje nisu snimljene</h5>
                      : <h5>Postoji povredna lista koja nije snimljena</h5>}

        <p>
            {capitalizeFirstLetter(moment(rescue.getTime()).calendar())}<br/>
            {rescue.rescue?.subject?.given_name} {rescue.rescue?.subject?.family_name}
        </p>
        
        <div className="buttons">
            <button onClick={cont} className="btn btn-primary"><i className="fa-solid fa-angles-right"/><span>Nastavi listu</span></button>
            {rescue.hasId ? <button onClick={reset} className="btn btn-danger"><i className="fa-solid fa-rotate-left"/><span>Odbaci izmene</span></button>
                          : <button onClick={reset} className="btn btn-danger"><i className="fa-solid fa-rotate-left"/><span>Nova lista</span></button>}

        </div>
    </section>

}